import AssetCreator from "@/pages/AssetCreator.vue";
import FormBuilder from "@/pages/FormBuilder.vue";
import QuizBuilder from "@/pages/QuizBuilder.vue";
import SurveyBuilder from "@/pages/SurveyBuilder.vue";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: "/form-builder-v2/:form_id",
    name: "form-builder-v2",
    component: FormBuilder,
  },
  {
    path: "/form-builder-v2/create",
    name: "form-builder-v2-create",
    component: AssetCreator,
    props: (route) => ({ source: route.query.source }),
  },
  {
    path: "/survey-builder-v2/create",
    name: "survey-builder-v2-create",
    component: AssetCreator,
    props: (route) => ({ source: route.query.source }),
  },
  {
    path: "/quiz-builder-v2/create",
    name: "quiz-builder-v2-create",
    component: AssetCreator,
    props: (route) => ({ source: route.query.source }),
  },
  {
    path: "/survey-builder-v2/:survey_id",
    name: "survey-builder-v2",
    component: SurveyBuilder,
  },
  {
    path: "/quiz-builder-v2/:quiz_id",
    name: "quiz-builder-v2",
    component: QuizBuilder,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export { router };
